import type { ThemeOptions } from "@mui/material";

export const dark = (): ThemeOptions =>
  ({
    palette: {
      energyRed: {
        contrastText: "rgb(104, 0, 20)",
        dark: "rgb(255, 159, 159)",
        light: "rgb(255, 199, 199)",
        main: "rgb(255, 179, 179)",
      },
      gray: {
        contrastText: "#000",
        dark: "oklch(0.71 0.02 261)", // Tailwind gray-400
        light: "oklch(0.98 0.00 248)", // Tailwind gray-50
        main: "oklch(0.93 0.01 265)", // Tailwind gray-200
      },
      mode: "dark",
      slate: {
        contrastText: "#000",
        dark: "oklch(0.71 0.04 257)", // Tailwind slate-400
        light: "oklch(0.98 0.00 248)", // Tailwind slate-50
        main: "oklch(0.93 0.01 256)", // Tailwind slate-200
      },
      tokens: {
        decorativeSurface: "oklch(0.93 0.01 256)", // Tailwind slate-200
        decorativeSurfaceContrast: "oklch(0.28 0.04 260)", // Tailwind slate-800
        greenSurface: "oklch(0.45 0.11 131)", // Tailwind lime-800
        greenSurfaceContrast: "oklch(0.41 0.10 131)", // Tailwind lime-900
        label: "oklch(0.93 0.01 256)", // Tailwind slate-200
        mutedSurface: "oklch(0.27 0.01 286)", // Tailwind zinc-800
        mutedSurfaceContrast: "oklch(0.87 0.02 253)", // Tailwind slate-300
        yellowSurface: "oklch(0.68 0.14 76)", // Tailwind slate-600
        yellowSurfaceContrast: "oklch(0.55 0.12 66)", // Tailwind yellow-700
      },
      white: {
        contrastText: "#000",
        dark: "#f5f5f5",
        light: "#ffffff",
        main: "#fff",
      },
    },
  }) as ThemeOptions;
